// extracted by mini-css-extract-plugin
export var printerCard = "_a9-1";
export var printerCardConfigured = "_a9-2";
export var printerCardError = "_a9-3";
export var printerCardsContainer = "_a9-0";
export var printerIcon = "_a9-8";
export var printerIconConfigured = "_a9-5";
export var printerIconContainer = "_a9-4";
export var printerIconError = "_a9-6";
export var printerIconUnconfigured = "_a9-7";